'use client'

import * as React from 'react'
import { TooltipProvider } from '@/components/ui/tooltip'
import { SiteHeader, SkipLink, MobileBar } from '@/components/homepage-october/sections/Chrome'
import { Footer } from '@/components/homepage-october/blocks/SiteFooter'
import { DestinationProvider } from '@/components/homepage-october/blocks/DestinationLink'
import { watchImages } from '@/components/homepage-october/blocks/Img'
import { ShopProvider, useShop } from '@/components/homepage-october/state'
import { useSiteChromeModel } from './site-chrome-context'
import type { SiteChromeModel } from './types'
import '../homepage-october/homepage.css'
import './public-site-chrome.css'

const Panels = React.lazy(() => import('@/components/homepage-october/blocks/ShoppingPanels').then(module => ({ default: module.Panels })))

function PublicShoppingPanels({ model }: { model: SiteChromeModel }) {
  const shop = useShop()
  if (!shop.panel) return null
  return <React.Suspense fallback={<div role="status" className="v3-panel-loading">Opening… <button type="button" onClick={shop.close}>Cancel</button></div>}><Panels model={model} /></React.Suspense>
}

export type SiteChromeProps = { indexedCollectionSlugs?: readonly string[] | null }

export function PublicSiteHeader({ indexedCollectionSlugs }: SiteChromeProps = {}) {
  const model = useSiteChromeModel()
  React.useEffect(() => watchImages(), [])
  const gates = indexedCollectionSlugs ? { ...model.destinations, collections: [...indexedCollectionSlugs] } : model.destinations
  return <div className="v3-public-chrome"><DestinationProvider gates={gates}><ShopProvider><TooltipProvider delayDuration={200}>
    <SkipLink m={model.header.skip} /><SiteHeader m={model.header} model={model} />
    <MobileBar m={model.mbar} /><PublicShoppingPanels model={model} />
  </TooltipProvider></ShopProvider></DestinationProvider></div>
}

export function PublicSiteFooter({ indexedCollectionSlugs }: SiteChromeProps = {}) {
  const model = useSiteChromeModel()
  const gates = indexedCollectionSlugs ? { ...model.destinations, collections: [...indexedCollectionSlugs] } : model.destinations
  return <div className="v3-public-footer"><DestinationProvider gates={gates}><Footer model={model} /></DestinationProvider></div>
}
